import { GLOBAL_SCOPE as r } from "./constants.js";
import { toResolvedBinding as l } from "./matching.js";
import { normalizeShortcut as h, compileShortcut as y } from "./shortcut.js";
function S(t, e) {
  return t[e];
}
function w(t, e) {
  if (typeof e.id != "string" || e.id.length === 0)
    throw new Error(`Binding in scope "${t}" must define a stable id.`);
}
function E(t, e) {
  w(t, e);
  const n = h(e.shortcut), s = y(n);
  return {
    scope: t,
    id: e.id,
    name: e.name,
    description: e.description,
    shortcut: n,
    action: e.action,
    acceptedEventKeys: s.acceptedEventKeys,
    duplicateShortcutId: s.duplicateShortcutId
  };
}
function K(t) {
  if (!t || typeof t != "object")
    throw new Error("defineInputSystem(...) expects an object keyed by scope.");
  const e = Object.keys(t);
  if (!e.includes(r))
    throw new Error(`defineInputSystem(...) requires a "${r}" scope.`);
  const n = [
    r,
    ...e.filter((o) => o !== r)
  ], s = {}, d = {}, p = /* @__PURE__ */ new Set();
  for (const o of n) {
    const m = S(t, o), u = /* @__PURE__ */ new Set(), a = m.map((f) => {
      const c = E(o, f);
      if (p.has(c.id))
        throw new Error(`Duplicate action id "${c.id}" found.`);
      if (p.add(c.id), c.acceptedEventKeys.some((i) => u.has(i)))
        throw new Error(
          `Duplicate shortcut "${c.duplicateShortcutId}" found in scope "${o}".`
        );
      for (const i of c.acceptedEventKeys)
        u.add(i);
      return c;
    });
    d[o] = a, s[o] = a.map(l);
  }
  return {
    scopes: n,
    bindings: s,
    compiledBindings: d
  };
}
export {
  K as compileInputSystem
};
